import { render, staticRenderFns } from "./sale-summary.vue?vue&type=template&id=4f296b84&"
import script from "./sale-summary.vue?vue&type=script&lang=js&"
export * from "./sale-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports